import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

/**
 * Componente para exibicao de mensagem de servico indisponivel
 * Exibido quando o endpoint EN4 esta indisponivel
 */
@Component({
  selector: 'app-service-unavailable',
  templateUrl: './service-unavailable.component.html',
  styleUrls: ['./service-unavailable.component.css']
})
export class ServiceUnavailableComponent {

  constructor(
    private router: Router,
    public translateService: TranslateService
  ) {}

  /**
   * Tenta recarregar a pagina
   */
  retry(): void {
    window.location.reload();
  }

  /**
   * Navega para a pagina inicial
   */
  goHome(): void {
    this.router.navigate(['/']);
  }
}
